<template>
  <div class="f-supportersPage">
    <div class="title-container">
      <h1>#AlpFoodwayUNESCO <br>{{activeLanguage.supportersPosition}}</h1>
    </div>

    <div id="progress">
      <div id="progress-bar"></div>
    </div>
    <div :id="getMapClass"></div>

<!--    <div class="supporterButton">-->
<!--      <b-button size="lg" style="background-color: #c41c21; height: 8vh" @click="loadBecomeSupporterModal">-->
<!--        {{activeLanguage.becomeSupporter}}-->
<!--      </b-button>-->
<!--      <BecomeSupporterModal ref="becomeSupporterModalExt"></BecomeSupporterModal>-->
<!--    </div>-->

    <div class="title-container">
      <h1>#AlpFoodway {{activeLanguage.mainSupporters}}</h1>
    </div>
    <main-supporters></main-supporters>
    <div class="title-container">
      <h1>{{activeLanguage.otherSupporters}}</h1>
    </div>
    <other-supporters></other-supporters>

  </div>
</template>

<script>
    import MainSupporters from './MainSupporters'
    import OtherSupporters from './OtherSupporters'
    import L from 'leaflet'
    import iconUrl from 'leaflet/dist/images/marker-icon.png'
    import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
    import BecomeSupporterModal from './BecomeSupporterModal'

    require('leaflet.markercluster')

    export default {
      name: 'SupportersPage',
      components: {
        BecomeSupporterModal,
        OtherSupporters,
        MainSupporters
      },
      computed: {
        activeLanguage () {
          return this.$translations[this.$store.getters.currentLanguageValue]
        },
        getMapClass () {
          return this.isSmallWindow ? 'map-mobile' : 'map'
        }
      },
      props: {
        default: {
          type: Object
        }
      },
      data () {
        return {
          isSmallWindow: false
        }
      },
      methods: {
        loadBecomeSupporterModal () {
          this.$refs.becomeSupporterModalExt.showModal()
        },
        loadSupporters () {
          let tiles, latlng
                // tiles = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
                //   maxZoom: 13,
                //   minZoom: 2,
                //   attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>'
                // })
                // tiles = L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
                //   maxZoom: 13,
                //   minZoom: 2,
                //   attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
                // })
          tiles = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 13,
            minZoom: 2,
            continuousWorld: true,
            attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
          })
          latlng = L.latLng(19.638534, -39.399043)
          let map = L.map('map', {center: latlng, zoom: 2.2, layers: [tiles], worldCopyJump: true})
          map.scrollWheelZoom.disable()
          map.on('click', function () {
            if (map.scrollWheelZoom.enabled()) {
              map.scrollWheelZoom.disable()
            } else {
              map.scrollWheelZoom.enable()
            }
          })
          let markers = L.markerClusterGroup({
            chunkedLoading: true,
            iconCreateFunction: function (cluster) {
              let markers = cluster.getAllChildMarkers()
              let n = 0
              for (let i = 0; i < markers.length; i++) {
                n += markers[i].petitions
              }
              let size = n.toString().length
              let xy = 0
              let className = ''
              let divClass = ''
              let spanStyle = ''
              if (size === 1) {
                xy = 30
                className = 'clusterIcon-1'
                divClass = 'divClass-1'
                spanStyle = '20px'
              } else if (size <= 4) {
                xy = 40
                className = 'clusterIcon-4'
                divClass = 'divClass-4'
                spanStyle = '30px'
              } else if (size <= 5) {
                xy = 50
                className = 'clusterIcon-6'
                divClass = 'divClass-6'
                spanStyle = '40px'
              } else if (size <= 10) {
                xy = 60
                className = 'clusterIcon-10'
                divClass = 'divClass-10'
                spanStyle = '50px'
              } else if (size > 10) {
                xy = 70
                className = 'clusterIcon-10'
                divClass = 'divClass-10'
                spanStyle = '60px'
              }
              return L.divIcon({
                html: '<div class="' + divClass + '"> <span style="line-height: ' + spanStyle + '">' + n + '</span></div>',
                iconSize: L.point(xy, xy),
                className: className
              })
            },
                    // spiderfyOnMaxZoom: false,
            singleMarkerMode: true,
            chunkProgress: this.updateProgressBar
          })
          let markerList = []
          this.$http.get(this.$PATH_NAME + 'petitions/cities/countAggregate').then(response => {
            let res = response.body
            Object.keys(res).forEach(function (key, index) {
              if (res[key].latitude && res[key].longitude) {
                let title = res[key].signatures
                let marker = L.marker(L.latLng(res[key].latitude, res[key].longitude))
                let icon = L.icon({iconUrl: iconUrl, shadowUrl: shadowUrl})
                marker.setIcon(icon)
                marker.petitions = title
                marker.on('mouseover', () => {
                  marker.bindPopup(key).openPopup()
                })
                marker.on('click', (a) => {
                  let latlng = L.latLng(a.latlng.lat, a.latlng.lng)
                  map.setZoomAround(latlng, 9)
                })
                markerList.push(marker)
              }
            })
          }).catch(function (err) {
            if (err.status >= 500) {
              console.log('Server-Related problem')
            } else if (err.status === 400) {
              console.log('A bad request occurred')
            } else if (err.status === 404) {
              console.log(err.body.message)
            }
          }).finally(() => {
            markers.addLayers(markerList)
            map.addLayer(markers)
          })
          document.getElementsByClassName('leaflet-top')[0].setAttribute('style', 'z-index: 974 !important;')
          document.getElementsByClassName('leaflet-bottom')[0].setAttribute('style', 'z-index: 974 !important;')
          document.getElementsByClassName('leaflet-bottom')[1].setAttribute('style', 'z-index: 974 !important;')
        },
        updateProgressBar (processed, total, elapsed, layersArray) {
          let progress = document.getElementById('progress')
          let progressBar = document.getElementById('progress-bar')
          if (elapsed > 1000) {
                    // if it takes more than a second to load, display the progress bar:
            progress.style.display = 'block'
            progressBar.style.width = Math.round(processed / total * 100) + '%'
          }

          if (processed === total) {
                    // all markers processed - hide the progress bar:
            progress.style.display = 'none'
          }
        },
        checkWindowSize () {
          if ((!this.isSmallWindow) && window.innerWidth < 1051) {
            this.isSmallWindow = true
          } else if (this.isSmallWindow && window.innerWidth > 1051) {
            this.isSmallWindow = false
          }
        }
      },
      mounted () {
        this.$store.commit('setCurrentView', this.default)
        this.loadSupporters()
        this.checkWindowSize()
        window.addEventListener('resize', () => this.checkWindowSize())
      }
    }
</script>
<style>
  .clusterIcon-1 {
    background-clip: padding-box;
    border-radius: 50%;
    background-color: rgba(181, 226, 140, 0.6);
    margin-left: -20px;
    margin-top: -20px;
  }

  .clusterIcon-4 {
    background-color: rgba(241, 211, 87, 0.6);
    background-clip: padding-box;
    border-radius: 50%;
    margin-left: -20px;
    margin-top: -20px;
  }

  .clusterIcon-6 {
    background-color: rgba(253, 156, 115, 0.6);
    background-clip: padding-box;
    border-radius: 50%;
    margin-left: -20px;
    margin-top: -20px;
  }

  .clusterIcon-10 {
    background-color: rgba(253, 105, 163, 0.6);
    background-clip: padding-box;
    border-radius: 50%;
    margin-left: -20px;
    margin-top: -20px;
  }

  .divClass-1 {
    width: 20px;
    height: 20px;
    margin-left: 5px;
    margin-top: 5px;
    text-align: center;
    border-radius: 15px;
    background-color: rgba(110, 204, 57, 0.6)
  }

  .divClass-4 {
    width: 30px;
    height: 30px;
    margin-left: 5px;
    margin-top: 5px;
    text-align: center;
    border-radius: 50%;
    background-color: rgba(240, 194, 12, 0.6);
  }

  .divClass-6 {
    width: 40px;
    height: 40px;
    margin-left: 5px;
    margin-top: 5px;
    text-align: center;
    border-radius: 50%;
    background-color: rgba(241, 128, 23, 0.6);
  }

  .divClass-10 {
    width: 50px;
    height: 50px;
    margin-left: 5px;
    margin-top: 5px;
    text-align: center;
    border-radius: 50%;
    background-color: rgba(253, 49, 106, 0.6);
  }

</style>
<style scoped>

  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

  #map {
    left: 0;
    right: 0;
    height: 620px;
    width: 80%;
    margin: auto auto 3%;
  }

  #map-mobile {
    left: 0;
    right: 0;
    height: 620px;
    margin: 0 auto;
    margin-bottom: 2em;
  }

  @media only screen and (max-width: 600px) {
    .title-container {
      margin: 0 0 2.5%;
    }

    .title-container > h1 {
      font-size: 1.0rem !important;
    }

    .title-container > h2 {
      font-size: 1.0rem !important;
    }
  }

  .supporterButton {
    /*border-bottom: solid 1px grey;*/
    /*width: 68%;*/
    left: 0;
    right: 0;
    margin: auto 20% 2.5%;
    color: #c41c21;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/supportersPageComponents/SupportersPage.vue